module.exports = __webpack_public_path__ + "media/images/svg/nist_logo_reverse-1a704bdd0258ec1ffc59eeb1500602bd.svg";